module.exports = __webpack_public_path__ + "static/img/app_base_63539443852c445e8682b27a3b0b662e_19.d7fd48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_base_63539443852c445e8682b27a3b0b662e_19.png
// module id = e+93
// module chunks = 1